<template>
  <div style="background: #eeeeee">
    <AppBar />
    <v-main>
      <router-view></router-view>
    </v-main>
  </div>
</template>

<script>
import AppBar from '@/components/organisms/common/navigation/AppBar'

export default {
  name: 'MenuRootPage',

  components: {
    AppBar,
  },
}
</script>
